import { render } from "./header-bar-brand.vue?vue&type=template&id=5abac1cc"
import script from "./header-bar-brand.vue?vue&type=script&lang=js"
export * from "./header-bar-brand.vue?vue&type=script&lang=js"
script.render = render

export default script